<template>
  <div id="sideBar" :class="{ shrinkBar: isCollapse }">
    <template>
      <!-- 有子層 -->
      <el-submenu
        v-if="item.children.length > 0"
        :index="String(item.ID)"
        :key="item.ID"
      >
        <!-- 父層 -->
        <template slot="title">
          <span class="menu-entry" v-if="item.children && item.children.length > 0">
            <span class="menu-entry__icon">
              <font-awesome-icon :icon="item.Icon"></font-awesome-icon>
            </span>
            <span class="title-name menu-entry__label" v-if="!isCollapse">
              {{ item.Name }}
            </span>
          </span>
        </template>
        <!-- 渲染子層路由 子層 -->
        <el-menu-item
          v-for="child in item.children"
          :key="child.ID"
          :index="child.Path"
          @click="$emit('doRoute', child.Path)"
        >
          <span class="menu-entry">
            <span class="menu-entry__icon">
              <font-awesome-icon :icon="child.Icon" />
            </span>
            <span class="title-name menu-entry__label menu-entry__label--child">{{ child.Name }}</span>
          </span>
        </el-menu-item>
      </el-submenu>

      <!-- 無子層 -->
      <template v-else>
        <el-menu-item
          v-if="item.Name !== '登出'"
          :index="item.Path"
          :key="item.ID"
          @click="$emit('doRoute', item.Path)"
        >
          <span class="menu-entry">
            <span class="menu-entry__icon">
              <font-awesome-icon :icon="item.Icon" />
            </span>
            <span class="title-name menu-entry__label" v-if="!isCollapse">{{ item.Name }}</span>
          </span>
        </el-menu-item>
        <el-menu-item v-else :index="item.Path" @click="signout()">
          <span class="menu-entry">
            <span class="menu-entry__icon">
              <font-awesome-icon :icon="item.Icon" />
            </span>
            <span class="title-name menu-entry__label" v-if="!isCollapse">{{ item.Name }}</span>
          </span>
        </el-menu-item>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    isCollapse: {
      type: Boolean,
      default: true,
      required: false,
    },
    item: {
      type: Object,
      required: false,
    },
  },
  methods: {
    async signout() {
      this.$confirm("確定要登出系統嗎？", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("loadingHandler", true);

        this.$store.dispatch("Logout").then(() => {
          window.localStorage.removeItem("userID");
          this.$notify({
            title: "成功",
            message: "您已成功登出!",
            type: "success",
          });
          console.log("/logout");
          this.$router.push("/logout");
        });

        this.$store.dispatch("loadingHandler", false);
      });
    },
  },
};
</script>

<style lang="scss">
#sideBar {
  .el-submenu__title,
  .el-menu-item {
    display: flex;
    align-items: center;
  }

  .menu-entry {
    display: inline-flex;
    align-items: center;
    width: 100%;
    min-width: 0;

    &__icon {
      width: 24px;
      min-width: 24px;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      .svg-inline--fa {
        width: 16px;
        height: 16px;
        display: block;
      }
    }

    &__label {
      margin-left: 8px;
      line-height: 1.2;

      &--child {
        font-size: 0.8rem;
      }
    }
  }

  &.shrinkBar {
    .el-submenu__title {
      justify-content: center;
      position: relative;
      padding-right: 22px !important;
    }

    .el-submenu__icon-arrow {
      right: 8px;
      margin-top: -4px;
    }

    .menu-entry {
      justify-content: center;
    }

    .menu-entry__label {
      display: none;
    }

    li,
    .el-tooltip {
      padding: 0 !important;
      text-align: center !important;
      i {
        margin-right: 0 !important;
      }
    }
  }

  .title {
    &-name {
      padding-left: 0;
    }
  }

}

.el-menu--popup {
  .menu-entry {
    display: inline-flex;
    align-items: center;
    width: 100%;
    min-width: 0;
  }

  .menu-entry__icon {
    width: 24px;
    min-width: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    .svg-inline--fa {
      width: 16px;
      height: 16px;
      display: block;
    }
  }

  .menu-entry__label {
    margin-left: 8px;
    line-height: 1.2;
  }

  .menu-entry__label--child {
    font-size: 0.8rem;
  }
}

  .el-menu-item:hover { 
    background-color: rgb(86, 151, 211) !important 
  }
</style>
